<template>
    <div class="aftermarketInfo">
        <Header
            v-if="typeObj[afterSalesOrder.type]"
            :pageTitle="typeObj[afterSalesOrder.type] + '详情'"
        />
        <div class="content">
            <!-- 顶部售后进度信息 -->
            <div class="content-item schedule_info_box">
                <h1 class="schedule_info_title">{{ processDto.name }}</h1>
                <p class="schedule_info_desc" v-html="processDtoDesc"></p>
                <van-button
                    v-if="afterSalesOrder.status === 7"
                    class="schedule_info_btn"
                    round
                    @click="logisticsShow = true"
                    >填写退货物流</van-button
                >
            </div>
            <!-- 买家填写退货物流信息 -->
            <van-popup
                class="intervene_popup"
                v-model="logisticsShow"
                closeable
                round
                position="bottom"
            >
                <p class="intervene_title">物流信息</p>
                <van-form validate-first>
                    <van-field
                        class="intervene_field"
                        v-model="expressCompanyName"
                        placeholder="请选择快递公司名称"
                        @input="expressCompanyChange"
                        :border="false"
                        clearable
                    />
                    <div class="intervene_list" v-show="expressCompanyPickerShow">
                        <van-loading
                            class="intervene_list_loading"
                            v-show="expressCompanyPickerLoading"
                        />
                        <p
                            v-show="!expressCompanyPickerLoading"
                            class="intervene_list_item"
                            v-for="item in expressCompanyList"
                            :key="item.code"
                            @click="selectExpressCompany(item.code, item.name)"
                        >
                            {{ item.name }}
                        </p>
                    </div>
                    <div v-show="!expressCompanyPickerShow">
                        <van-field
                            class="intervene_field"
                            v-model="waybillNumber"
                            placeholder="请输入物流单号"
                            maxlength="30"
                            :border="false"
                            clearable
                        />
                        <van-button
                            class="intervene_btn"
                            round
                            type="info"
                            @click="expressCompanyConfirm"
                            >确定</van-button
                        >
                    </div>
                </van-form>
            </van-popup>
            <!-- 卖家地址信息 -->
            <div class="content-item merchant_box" v-if="afterSalesOrder.status === 7">
                <h3 class="merchant_name">
                    收件人：{{ sellerInfo.consignee
                    }}<span class="merchant_phone">{{ sellerInfo.phone }}</span>
                </h3>
                <p class="merchant_address">
                    {{ sellerInfo.provinceName }} {{ sellerInfo.cityName }}
                    {{ sellerInfo.districtName }} {{ sellerInfo.streetName }}
                    {{ sellerInfo.detailAddress }}
                </p>
            </div>
            <!-- 退/换货详情 -->
            <div class="content-item express_detail" v-if="expressList.length > 0">
                <div class="detail_cell" v-for="item in expressList" :key="item.expressType">
                    <van-cell
                        v-if="item.expressType === 2"
                        title="换货详情"
                        is-link
                        @click="toExpressDetail(item.expressType)"
                    />
                    <van-cell
                        v-if="item.expressType === 1"
                        title="退货详情"
                        is-link
                        @click="toExpressDetail(item.expressType)"
                    />
                </div>
            </div>
            <!-- 售后详情信息 -->
            <div class="aftermarket-box content-item">
                <div class="goods-box">
                    <div class="left">
                        <img
                            :src="
                                goodsObj.albumPics
                                    ? $global.imgUrl + goodsObj.albumPics.split(',')[0]
                                    : require('@/assets/img/mobile-img/zz_default.png')
                            "
                            alt=""
                        />
                    </div>
                    <div class="right">
                        <div class="goods-title">
                            {{ goodsObj.goodsName }}
                        </div>
                        <div class="goods-content">
                            <span v-html="goodsObj.specificationsValueOne"></span>
                            <span v-html="goodsObj.specificationsValueTwo"></span>
                        </div>
                    </div>
                </div>
                <div class="item-box">
                    <div class="left">售后单号</div>
                    <div class="right">{{ afterSalesOrder.orderNumber }}</div>
                </div>
                <div class="item-box">
                    <div class="left">申请时间</div>
                    <div class="right">{{ afterSalesOrder.createTime }}</div>
                </div>
                <div class="item-box">
                    <div class="left">服务类型</div>
                    <div class="right">{{ typeObj[afterSalesOrder.type] }}</div>
                </div>
                <template>
                    <div class="item-box" v-if="afterSalesOrder.type !== 3">
                        <div class="left">{{ afterSalesOrder.type | titleFilter }}数量</div>
                        <div class="right">{{ afterSalesOrder.returnCount }}</div>
                    </div>
                    <div class="item-box" v-if="afterSalesOrder.exField">
                        <div class="left">参会人</div>
                        <div class="right">{{ participant(afterSalesOrder.exField) }}</div>
                    </div>
                    <div class="item-box" v-if="afterSalesOrder.refundAmount">
                        <div class="left">退款金额</div>
                        <div class="right">￥{{ afterSalesOrder.refundAmount }}</div>
                    </div>
                </template>
                <div class="item-box">
                    <div class="left">申请原因</div>
                    <div class="right">{{ afterSalesOrder.reasonValue }}</div>
                </div>
                <div class="item-box">
                    <div class="left">问题描述</div>
                    <div class="right">
                        {{ afterSalesOrder.problemDesc ? afterSalesOrder.problemDesc : "-" }}
                    </div>
                </div>
                <div class="item-box" v-if="afterSalesOrder.mediaPaths">
                    <div class="left"></div>
                    <div class="right">
                        <img
                            class="right-img"
                            v-for="(item, index) in afterSalesOrder.mediaPaths.split(',')"
                            :key="index"
                            :src="$global.imgUrl + item"
                            alt=""
                            @click="toRreview(index)"
                        />
                    </div>
                </div>
            </div>
            <!-- 售后进度 -->
            <van-cell class="schedule_box" title="售后进度" is-link @click="toSchedule" />
        </div>
        <div class="footer">
            <van-button v-if="showReapplyBtn" class="footer_btn" round @click="toReapply"
                >重新申请</van-button
            >
            <van-button v-if="showInterveneBtn" class="footer_btn" round @click="toClose"
                >关闭售后</van-button
            >
            <van-button
                v-if="showInterveneBtn"
                class="footer_btn"
                round
                @click="interveneShow = true"
                >平台介入</van-button
            >
            <van-button v-if="showRepealBtn" class="footer_btn repeal_btn" round @click="toRepeal"
                >撤销申请</van-button
            >
            <van-button
                v-if="afterSalesOrder.status === 10"
                class="footer_btn"
                round
                @click="confirmReceipt"
                >确认收货</van-button
            >
            <van-button
                v-if="afterSalesOrder.status === 10"
                class="footer_btn"
                round
                @click="lengthenReceipt"
                >延长收货时间</van-button
            >
        </div>
        <TipsDialog
            :showDialog="showDialog"
            @dialogCancel="showDialog = false"
            @dialogConfirm="dialogConfirm"
        >
            <p>{{ tipsDialogText }}</p>
        </TipsDialog>
        <van-popup
            class="intervene_popup"
            v-model="interveneShow"
            closeable
            round
            position="bottom"
        >
            <p>如需平台客服进行介入，需您提供相关凭证</p>
            <van-form validate-first>
                <van-field
                    class="intervene_textarea"
                    v-model="interveneText"
                    type="textarea"
                    rows="5"
                    maxlength="100"
                    show-word-limit
                />
                <van-uploader
                    class="intervene_upload"
                    v-model="preivewFileList"
                    :max-count="10"
                    :max-size="2 * 1024 * 1024"
                    :before-read="beforeRead"
                    :after-read="clzpAfterRead"
                    @delete="toDelete"
                    @oversize="onOversize"
                >
                    <div class="intervene_upload_box">
                        <van-icon name="plus" size="20" />
                        <p>上传凭证</p>
                        <p>（最多十张）</p>
                    </div>
                </van-uploader>
                <van-button class="intervene_btn" round type="info" @click="toIntervene"
                    >确定</van-button
                >
            </van-form>
        </van-popup>
    </div>
</template>
<script>
import { Dialog, ImagePreview } from "vant";
import Header from "@/views/mobileView/components/header/index.vue";
import TipsDialog from "@/views/mobileView/components/tipsDialog.vue";
export default {
    components: {
        Header,
        TipsDialog,
    },
    data() {
        return {
            typeObj: {
                1: "换货",
                2: "退货退款",
                3: "仅退款",
            },
            interveneShow: false,
            showDialog: false,
            tipsDialogText: "",
            tipsDialogType: "",
            goodsObj: {},
            afterSalesOrder: {},
            processDto: {},
            processDtoDesc: "",
            afterSalesTimes: 0,
            timer: null,
            interveneText: "",
            interveneFileList: [],
            preivewFileList: [],
            sellerInfo: {},
            logisticsShow: false,
            expressShow: false,
            expressCompany: "",
            expressCompanyName: "",
            waybillNumber: "",
            expressCompanyList: [],
            expressCompanyPickerShow: false,
            expressCompanyPickerLoading: false,
            expressList: [],
        };
    },
    computed: {
        // afterSalesOrder -> status订单状态 interveneStatus 平台介入状态
        //   interveneStatus -> 1平台未介入 2平台处理中 3支持买家 4支持卖家
        //   status -> 0 1 2 3 4 5 6 7 8 9 10 11 12
        //   status === 2 || 5 => 显示重新申请按钮
        //   (status === 0 || 6 || 7 || 9 || 10) || (interveneStatus === 2) => 显示撤销申请按钮
        //   (status === 1 || 8 || 11) && (interveneStatus !==2) => 显示平台介入按钮 / 显示关闭售后按钮
        //   (status === 1) && (interveneStatus !==2 ) => 显示关闭售后按钮
        showReapplyBtn() {
            return this.afterSalesOrder.status === 2 || this.afterSalesOrder.status === 5;
        },
        // showCloseBtn() {
        //   return this.afterSalesOrder.status === 1 && this.afterSalesOrder.status === 8 && this.afterSalesOrder.status === 1 && this.afterSalesOrder.interveneStatus !== 2
        // },
        showInterveneBtn() {
            return (
                (this.afterSalesOrder.status === 1 ||
                    this.afterSalesOrder.status === 8 ||
                    this.afterSalesOrder.status === 11) &&
                this.afterSalesOrder.interveneStatus !== 2
            );
        },
        showRepealBtn() {
            return (
                this.afterSalesOrder.status === 0 ||
                this.afterSalesOrder.status === 6 ||
                this.afterSalesOrder.status === 7 ||
                this.afterSalesOrder.status === 9 ||
                this.afterSalesOrder.status === 10 ||
                this.afterSalesOrder.interveneStatus === 2
            );
        },
    },
    filters: {
        titleFilter(value) {
            switch (Number(value)) {
                case 1:
                    return "换货";
                case 2:
                    return "退货";
                case 3:
                    return "退款";
            }
        },
    },
    async created() {
        await this.detail();
    },
    methods: {
        // 参会人
        participant(arr) {
            let name = "";
            if (arr) {
                let newArr = JSON.parse(arr);
                name = newArr
                    .map((item) => {
                        return item.name;
                    })
                    .join();
            }
            return name;
        },
        // 浏览问题描述图片
        toRreview(index) {
            let images = this.afterSalesOrder.mediaPaths
                .split(",")
                .map((item) => this.$global.imgUrl + item);
            ImagePreview({
                images,
                startPosition: index,
            });
        },
        // 详情
        async detail() {
            let res = await this.$apis.afterSalesOrder.detailOrder({ id: this.$route.query.id });
            this.goodsObj = res.data.goods; // 商品信息
            this.afterSalesOrder = res.data.afterSalesOrder; // 售后信息
            this.processDto = JSON.parse(res.data.processDto.currentInfos).descriptor.buyer; // 售后进度说明
            if (this.processDto.hasOwnProperty("redisKey")) {
                this.getDescTime(this.processDto.redisKey);
            } else {
                this.processDtoDesc = this.processDto.desc;
            }
            this.sellerInfo = res.data.sellerReceipt; // 商家信息(地址)
            this.expressList = res.data.afterSaleExpressDtoList; // 退换货详情内容
        },
        // 获取售后进度时间
        async getDescTime(redisKey) {
            let res = await this.$apis.afterSalesOrder.getRemainderTime({
                afterSalesOrderIdId: this.$route.query.id,
                redisKey,
            });
            if (res.resultCode === "200") {
                this.afterSalesTimes = Number(res.data) + 15; // +15s 作页面刷新容错
                this.timeFormatter();
                this.countdown();
            }
        },
        // 设置倒计时器
        countdown() {
            this.timer = setInterval(() => {
                if (this.afterSalesTimes == 0) {
                    // 计时结束，清除缓存
                    clearInterval(this.timer);
                    this.$router.go(0);
                } else {
                    this.afterSalesTimes--;
                    this.timeFormatter();
                }
            }, 1000);
        },
        // 倒计时时间格式化
        timeFormatter() {
            let day = parseInt(this.afterSalesTimes / 60 / 60 / 24);
            let hr = parseInt((this.afterSalesTimes / 60 / 60) % 24);
            let min = parseInt((this.afterSalesTimes / 60) % 60);
            let sec = parseInt(this.afterSalesTimes % 60);
            day = day > 9 ? day : "0" + day;
            hr = hr > 9 ? hr : "0" + hr;
            min = min > 9 ? min : "0" + min;
            sec = sec > 9 ? sec : "0" + sec;
            let timerStr = `<span class="schedule_info_desc_time">${day}天${hr}时${min}分${sec}秒</span>`;
            this.processDtoDesc = this.processDto.desc.replace(/%s/g, timerStr);
        },
        // 提示弹窗点击确定
        async dialogConfirm() {
            switch (this.tipsDialogType) {
                case "repeal":
                    let repealRes = await this.$apis.afterSalesOrder.repealAfterSale({
                        id: this.afterSalesOrder.id,
                    });
                    if (repealRes.resultCode === "200") {
                        this.$toast("撤销成功");
                        this.$router.go(-1);
                    } else {
                        this.$toast(repealRes.resultDesc);
                    }
                    break;
                case "close":
                    let closeRes = await this.$apis.afterSalesOrder.closeAfterSales({
                        id: this.afterSalesOrder.id,
                    });
                    if (closeRes.resultCode === "200") {
                        this.$toast("关闭成功");
                        this.$router.go(-1);
                    } else {
                        this.$toast(closeRes.resultDesc);
                    }
                    break;
                case "confirm":
                    const confirmRes = await this.$apis.afterSalesOrder.toConfirmReceipt({
                        afterSalesOrderId: this.afterSalesOrder.id,
                    });
                    if (confirmRes.resultCode === "200") {
                        this.$toast("确认收货成功！");
                        this.$router.go(-1);
                    } else {
                        this.$toast(confirmRes.resultDesc);
                    }
                    break;
                case "lengthen":
                    const lengthenRes = await this.$apis.afterSalesOrder.toLengthenReceipt({
                        afterSalesOrderId: this.afterSalesOrder.id,
                        redisKey: this.processDto.redisKey,
                    });
                    if (lengthenRes.resultCode === "200") {
                        this.$toast("延长收货时间成功！");
                        this.$router.go(-1);
                    } else {
                        this.$toast(lengthenRes.resultDesc);
                    }
                    break;
                default:
                    this.showDialog = false;
                    break;
            }
        },
        // 重新申请
        async toReapply() {
            const res = await this.$apis.afterSalesOrder.reapplyVerify({
                orderGoodsId: this.afterSalesOrder.orderGoodsId,
                subOrderId: this.afterSalesOrder.subOrderId,
            });
            if (res.resultCode === "200") {
                switch (res.content.code) {
                    case 200:
                        this.$router.push({
                            path: "/selectAfterSalesType",
                            query: {
                                id: this.goodsObj.id,
                                goodsType: this.goodsObj.goodsType,
                            },
                        });
                        break;
                    case "10401003":
                        this.tipsDialogText =
                            "抱歉，订单已超过售后申请时效！如有疑问请联系平台：010 - 82615505";
                        this.showDialog = true;
                        this.tipsDialogType = "overtime";
                        break;
                    case "10401004":
                        this.tipsDialogText =
                            "售后申请次数已达上限，无法申请售后！如有疑问请联系平台：010 - 82615505";
                        this.showDialog = true;
                        this.tipsDialogType = "overtime";
                        break;
                    case "10401005":
                        this.$toast("存在进行中的售后，请勿重复提交！");
                        break;
                }
            }
        },
        // 关闭申请
        async toClose() {
            this.tipsDialogText = "确认关闭该售后申请吗？";
            this.showDialog = true;
            this.tipsDialogType = "close";
        },
        // 平台介入
        async toIntervene() {
            if (this.interveneText !== "" || this.interveneFileList.length > 0) {
                let mediaPaths = this.interveneFileList.join(",");
                const res = await this.$apis.afterSalesOrder.applyIntervene({
                    afterSalesOrderId: this.afterSalesOrder.id,
                    detail: {
                        interveneDesc: this.interveneText,
                        mediaPaths,
                        type: this.afterSalesOrder.interveneStatus,
                    },
                });
                if (res.resultCode === "200") {
                    this.$toast("提交成功");
                    this.interveneShow = false;
                    this.$router.go(-1);
                } else {
                    this.$toast(res.resultDesc);
                }
            } else {
                this.$toast("请输入相关凭证内容！");
            }
        },
        // 撤销售后申请
        toRepeal() {
            this.tipsDialogText = "确认撤销本次申请吗？如果问题未解决您可以再次发起售后";
            this.showDialog = true;
            this.tipsDialogType = "repeal";
        },
        // 确认收货
        async confirmReceipt() {
            this.tipsDialogText = "确认收到货了吗？";
            this.showDialog = true;
            this.tipsDialogType = "confirm";
        },
        // 延长收货
        async lengthenReceipt() {
            this.tipsDialogText = "确认延长7天收货时间？（仅可延长一次）";
            this.showDialog = true;
            this.tipsDialogType = "lengthen";
        },
        //校验图片的格式
        beforeRead(file) {
            if (!/(jpg|jpeg|png|JPG|PNG)/i.test(file.type)) {
                this.$toast("仅支持JPG、JPEG、PNG格式");
                return false;
            }
            return true;
        },
        // 上传文件
        async clzpAfterRead(file, { index }) {
            const _this = this;
            file.status = "uploading";
            file.message = "上传中...";
            // 创建一个空对象实例
            let formData = new FormData();
            // 调用append()方法添加数据
            formData.append("file", file.file);
            const res = await _this.$apis.myServe.uploadFileMannual(formData);
            if (res.resultCode == 200) {
                file.status = "done";
                file.message = "上传成功";
                this.interveneFileList[index] = res.content.url;
                this.preivewFileList[index].url = this.$global.imgUrl + res.content.url;
            } else {
                file.status = "failed";
                file.message = "failed";
                this.$toast(res.resultDesc);
            }
        },
        toDelete(_, { index }) {
            this.interveneFileList.splice(index, 1);
        },
        onOversize() {
            this.$toast("图片大小不能超过2MB");
        },
        // 跳转售后进度页面
        toSchedule() {
            this.$router.push({
                path: "/aftermarketSchedule",
                query: { id: this.$route.query.id },
            });
        },
        // 物流快递公司输入框变化时,获取快递公司列表
        expressCompanyChange(name) {
            this.expressCompany = "";
            console.log(name, "输入框变了");
            if (name !== "") {
                this.expressCompanyPickerShow = true;
                this.expressCompanyPickerLoading = true;
                this.$preventFun.Debounce(async () => {
                    this.expressCompanyList = [];
                    const res = await this.$apis.myServe.getExpressCompanyList({ name });
                    if (res.resultCode === "200") {
                        this.expressCompanyList = res.data.map((item) => ({
                            name: item.name,
                            code: item.code,
                        }));
                        this.expressCompanyPickerLoading = false;
                    }
                    console.log(res, "res");
                }, 600)();
            } else {
                this.expressCompanyPickerShow = false;
            }
        },
        // 选择物流公司
        selectExpressCompany(code, name) {
            this.expressCompanyPickerShow = false;
            this.expressCompanyName = name;
            this.expressCompany = code;
        },
        // 买家提交物流信息
        async expressCompanyConfirm() {
            if (this.expressCompany === "" || this.waybillNumber === "") {
                this.$toast("请填写完整物流信息！");
                return;
            }
            const res = await this.$apis.afterSalesOrder.submitBuyerLogistics({
                expressCompany: this.expressCompany,
                waybillNumber: this.waybillNumber,
                afterSalesOrderId: this.afterSalesOrder.id,
            });
            console.log(res, "res");
            if (res.resultCode === "200") {
                this.$toast("提交物流信息成功！");
                this.$router.go(-1);
            } else {
                this.$toast(res.resultDesc);
            }
        },
        // 跳转物流详情
        toExpressDetail(key) {
            this.$router.push({
                path: "/materialFlow",
                query: { id: this.$route.query.id, key },
            });
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
};
</script>
<style lang="scss">
html,
body {
    height: 100%;
    background: #f5f5f5;
}

.aftermarketInfo {
    position: relative;
    width: 100%;
    height: 100%;
    padding-top: calc(constant(safe-area-inset-top) + 44px) !important;
    padding-top: calc(env(safe-area-inset-top) + 44px) !important;

    .content {
        overflow: auto;
        padding: 0 12px 70px;
        width: 100%;

        .content-item {
            margin-top: 12px;
            padding: 0 16px;
            width: calc(100% - 1px);
            background-color: #fff;
            border: 1px solid white;
            border-radius: 8px;
            font-size: 14px;
            color: #333333;
        }

        .express_detail {
            .detail_cell {
                padding-bottom: 13px;
                padding-top: 13px;

                .van-cell {
                    padding: 0;

                    &::after {
                        display: none;
                    }
                }

                &:nth-child(2n) {
                    border-top: 1px solid #eee;
                }
            }
        }

        .schedule_info_box {
            padding: 14px 16px;

            .schedule_info_title {
                margin-bottom: 8px;
                font-size: 14px;
                color: #333333;
                line-height: 20px;
            }

            .schedule_info_desc {
                font-size: 13px;
                color: #999999;
                line-height: 20px;

                .schedule_info_desc_time {
                    color: red;
                }
            }

            .schedule_info_btn {
                margin-top: 17px;
                width: 100%;
                height: 35px;
                border-color: #4a79f1;
                color: #4a79f1;

                &:active {
                    &::before {
                        opacity: 0;
                    }
                }
            }
        }

        .wuliu {
            .van-field__body {
                input {
                    border: 1px solid #ddd !important;
                    background: #fff !important;
                }
            }
        }

        .step-box {
            padding: 0 8px;
            height: 78px;

            .van-steps {
                padding: 0 30px 20px;

                .van-steps__items {
                    .van-step__circle {
                        width: 10px;
                        height: 10px;
                    }

                    .van-step__icon--active {
                        width: 23px;
                        height: 23px;

                        img {
                            width: 23px;
                            height: 23px;
                        }
                    }
                }

                .van-step--horizontal {
                    .van-step__title {
                        transform: translate(-35%, 260%);
                    }

                    &:first-child .van-step__title {
                        transform: translate(-50%, 260%);
                    }

                    &:last-child .van-step__title {
                        transform: translate(50%, 260%);
                    }
                }
            }
        }

        .cause-box {
            display: flex;
            justify-content: space-between;
            padding-top: 20px;
            padding-bottom: 20px;

            .left {
                width: 80px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
            }

            .right {
                flex: 1;
                font-size: 15px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 500;
                color: #333333;
            }
        }

        .aftermarket-box {
            width: 100%;
            padding-top: 14px;
            padding-bottom: 12px;

            .goods-box {
                display: flex;
                justify-content: space-between;
                margin-bottom: 24px;

                .left {
                    width: 80px;
                    height: 80px;
                    border: 1px solid transparent;
                    border: none;
                    border-radius: 6px;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .right {
                    flex: 1;
                    margin-left: 10px;

                    .goods-title {
                        color: #333333;
                        overflow: hidden;
                        font-size: 15px;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        height: 45px;
                    }

                    .goods-content {
                        width: 90%;
                        padding-left: 0;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 1;
                        -webkit-box-orient: vertical;
                        margin-top: 10px;
                        color: #b2b2b2;
                        font-size: 13px;
                        font-weight: 400;
                        height: auto;
                    }
                }
            }

            .title {
                padding-bottom: 12px;
                border-bottom: 1px solid #eeeeee;
                margin-bottom: 14px;
            }

            // padding: 10px 0;
            .item-box {
                display: flex;
                justify-content: space-between;
                padding-bottom: 10px;

                .left {
                    width: 80px;
                    min-width: 80px;
                }

                .right {
                    width: calc(100% - 80px);
                    word-wrap: break-word;
                    text-align: right;

                    .right-img {
                        margin-left: 5px;
                        width: 70px;
                        height: 70px;
                        border-radius: 6px;
                    }
                }
            }
        }

        .openLogistics {
            border: 1px solid transparent;
            border-radius: 20px;
            padding: 0 23px;
            margin: 10px auto 0;
            display: block;
        }

        .van-cell {
            flex-wrap: wrap;

            .van-field__label {
                width: 100%;
                margin-bottom: 10px;
            }

            .van-field__body {
                input {
                    height: 50px;
                    background: rgba(242, 242, 242, 1);
                    border: 1px solid transparent;
                    border-radius: 5px;
                    padding-left: 10px;
                }
            }
        }

        .van-badge {
            background: yellow;
            color: #333333;
        }

        .van-popup {
            border: 1px solid transparent;
            border: none;
            border: 5;
            border-radius: 16px 16px 0px 0px;
            overflow: auto;
        }

        .schedule_box {
            margin-top: 12px;
            border-radius: 8px;
        }

        .merchant_box {
            padding-top: 13px;
            padding-bottom: 13px;

            .merchant_name {
                margin-bottom: 10px;
                font-size: 15px;
                color: #333333;
                line-height: 21px;

                .merchant_phone {
                    margin-left: 20px;
                    font-weight: 400;
                    font-size: 12px;
                    color: #999999;
                }
            }

            .merchant_address {
                font-size: 14px;
                color: #999999;
                line-height: 20px;
            }
        }
    }

    .footer {
        width: 100%;
        position: fixed;
        bottom: 0;
        background: #fff;
        text-align: right;

        .footer_btn {
            margin: 10px 0;
            margin-right: 10px;
            height: 35px;
            border-color: #999;

            &:active {
                &::before {
                    opacity: 0;
                }
            }
        }

        .repeal_btn {
            border-color: #397bf9;
            color: #397bf9;
        }
    }

    .intervene_popup {
        padding: 15px;

        .intervene_title {
            margin-bottom: 20px;
        }

        .intervene_textarea {
            position: relative;
            margin-top: 20px;
            padding: 0;

            &::after {
                display: none;
            }

            .van-field__body {
                border-radius: 8px;
                border: 1px solid #b2b2b2;
            }
        }

        .intervene_upload {
            margin-top: 20px;

            .van-uploader__input-wrapper {
                .intervene_upload_box {
                    padding-top: 10px;
                    width: 80px;
                    height: 80px;
                    text-align: center;
                    border: 1px dotted #b2b2b2;
                    border-radius: 4px;

                    p {
                        font-size: 12px;
                    }
                }
            }
        }

        .intervene_field {
            margin-top: 10px;
            padding: 0;

            .van-field__body {
                padding-right: 10px;
                border-radius: 8px;
                border: 1px solid #b2b2b2;

                .van-field__control {
                    border-radius: 8px;
                    background-color: #fff;
                }
            }
        }

        .intervene_list {
            margin: 10px 0;
            height: 280px;
            overflow-y: auto;

            .intervene_list_loading {
                margin-top: 10px;
                text-align: center;
            }

            .intervene_list_item {
                text-align: center;
                font-size: 16px;
                line-height: 50px;
            }
        }

        .intervene_btn {
            display: block;
            margin: 20px 0 10px;
            width: 100%;
        }
    }
}
</style>
